import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { MainLayoutRouting } from './main.routing';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    MainLayoutRouting,
  ],
  declarations: [
  ],
  exports: [
  ]
})
export class MainModule {}
